// @flow
'use strict'

const maybe = require('folktale/maybe')
const isPlainObject_ = require('lodash/isPlainObject')

const { resolveDynamicProperties } = require('./dynamicProperties')
const emptyConnectionConfig = require('../helpers/emptyConnectionConfig')
const componentTypes = require('dbsm-common/src/componentTypes')

/*::
import type { GetFieldType } from '../schemas/types'
import type {
  Component,
  Selector,
} from '../viewer-app-module/platformTypes'
import type { ComponentAdapter, ComponentAdapterContext } from './types'

type ComponentAdapterContextCreatorArgs = {
  getFieldType: GetFieldType,
  role: string,
  component: Component,
  $w?: Selector,
  api: ComponentAdapter
}
*/

const swapComponentByTypeHandlers = {
  [componentTypes.Page]: ({ $w }) => $w('Document')
}

const createAdapterContext = (
  {
    getFieldType,
    role,
    component,
    $w,
    api
  } /*: ComponentAdapterContextCreatorArgs */
) /*: ComponentAdapterContext */ => {
  const swapComponentByType = swapComponentByTypeHandlers[component.type]
  const connectionConfig = maybe
    .fromNullable(component.connectionConfig)
    .filter(isPlainObject_)
    .map(connectionConfig =>
      resolveDynamicProperties({ connectionConfig }, role, getFieldType)
    )
    .getOrElse(emptyConnectionConfig)

  const adapterContext = {
    role,
    connectionConfig,
    component: swapComponentByType ? swapComponentByType({ $w }) : component,
    api
  }

  return adapterContext
}

module.exports.createAdapterContext = createAdapterContext



// WEBPACK FOOTER //
// ./components/context.js